import { CSSProperties, Dispatch, SetStateAction, useEffect, useRef, useState } from "react";
import { ChevronDownGreyIcon } from "../../asset/image";
import { ITag } from "../../shared/db";
import { useSelectTheme } from "../../store";
import { Button, Checkbox } from "../atoms";
import { RIF } from "../../engine";
import { useClickOutside } from "../../engine";

export const ParticipantTagsFilter = (props: {
  fullTagList: ITag[];
  selectedTagList: ITag[];
  setSelectedTagList: (tags: ITag[]) => void;
  untagged: boolean;
  setUntagged: Dispatch<SetStateAction<boolean>>;
  size?: "large" | "normal";
}) => {
  const { color, fontSize } = useSelectTheme();
  const { fullTagList, selectedTagList, setSelectedTagList, untagged, setUntagged, size } = props;
  const [tempSelectedTagList, setTempSelectedTagList] = useState<ITag[]>([]);
  const [tempUntagged, setTempUntagged] = useState<boolean>(untagged);
  const [showDropdown, setShowDropdown] = useState(false);
  useEffect(() => {
    if (showDropdown) {
      setTempSelectedTagList(selectedTagList);
    }
  }, [showDropdown]);

  const ref = useRef(null);
  useClickOutside(ref, () => {
    setShowDropdown(false);
  });

  const handleToggleTags = (checked: boolean, tagId: string) => {
    if (checked) {
      const findResult = fullTagList.find((t) => t.id === tagId);
      if (!findResult) return;
      setTempSelectedTagList([...tempSelectedTagList, findResult]);
    } else {
      setTempSelectedTagList(tempSelectedTagList.filter((t) => t.id !== tagId));
    }
  };

  const handleApply = () => {
    if (tempSelectedTagList.length || untagged) setSelectedTagList(tempSelectedTagList);
    setUntagged(tempUntagged);
    setShowDropdown(false);
  };

  const handleClick = () => {
    setShowDropdown((prev) => !prev);
  };

  return (
    <div
      ref={ref}
      css={{
        position: "relative",
      }}
    >
      <button
        type="button"
        onClick={handleClick}
        css={{
          height: size === "large" ? "40px" : "32px",
          width: "160px",
          borderRadius: "5px",
          border: `1px solid ${color.border.default}`,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "0 8px",
          background: color.white,
          cursor: "pointer",
        }}
      >
        <p
          css={{
            fontSize: fontSize.h7,
            color: color.textIcon.secondary,
          }}
        >
          {selectedTagList.length === fullTagList.length && untagged
            ? "All Tags"
            : `${selectedTagList.length} Tag(s) Selected`}
        </p>
        <img src={ChevronDownGreyIcon} alt="Toggle dropdown" width={20} />
      </button>
      {RIF(
        showDropdown,
        <div
          css={{
            position: "absolute",
            left: "0",
            top: "34px",
            width: "160px",
            borderRadius: "5px",
            border: `1px solid ${color.border.default}`,
            padding: "16px",
            background: color.white,
            zIndex: 100,
            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
          }}
        >
          {fullTagList.map((tag: ITag) => (
            <label
              key={tag.id}
              css={{
                display: "flex",
                alignItems: "center",
                height: "24px",
                marginBottom: "4px",
                cursor: "pointer",
                gap: "8px",
              }}
            >
              <Checkbox
                onChange={(e: boolean) => handleToggleTags(e, tag.id)}
                value={tempSelectedTagList.some((t) => t.id === tag.id)}
              />
              <div
                css={{
                  display: "inline-flex",
                  alignItems: "center",
                  maxHeight: "17px",
                  height: "17px",
                  maxWidth: "102px",
                  padding: "0 6px",
                  borderRadius: "5px",
                  backgroundColor: `#${tag.color}1A`,
                }}
              >
                <span
                  css={{
                    maxWidth: "100%",
                    color: `#${tag.color}`,
                    fontSize: fontSize.h8,
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    pointerEvents: "none",
                  }}
                >
                  {tag.value}
                </span>
              </div>
            </label>
          ))}
          <label
            css={{
              display: "flex",
              alignItems: "center",
              height: "24px",
              marginBottom: "4px",
              cursor: "pointer",
              gap: "8px",
            }}
          >
            <Checkbox onChange={() => setTempUntagged(!tempUntagged)} value={tempUntagged} />
            <div
              css={{
                display: "inline-flex",
                alignItems: "center",
                maxHeight: "17px",
                height: "17px",
                maxWidth: "102px",
                padding: "0 6px",
                borderRadius: "5px",
                backgroundColor: color.surface.default,
              }}
            >
              <span
                css={{
                  maxWidth: "100%",
                  color: color.textIcon.secondary,
                  fontSize: fontSize.h8,
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                Untagged
              </span>
            </div>
          </label>
          <Button
            onClick={handleApply}
            btnPadding={"small"}
            css={{ marginTop: "12px", fontSize: fontSize.h7 }}
            children={"Apply"}
          />
        </div>,
      )}
    </div>
  );
};
